import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { rgba } from 'polished';
import { TableCell, TableRow } from '@this/src/components/shared/ui/data_displays/table';
import type AnaBookingInventoryItem from '@this/src/domain/arrangement/ana_booking_inventory_item';
import { Link } from '@this/src/components/shared/ui/navigations/link';
import { Button } from '@this/components/shared/ui/inputs/button';
import { Checkbox } from '@this/src/components/shared/ui/inputs/checkbox';
import { Fetcher } from '@this/src/util';
import InventoryCommentModal from '@this/components/arrangement/todo_list/auto_reservation_inventory/ana_booking/inventory_comment_modal';

interface Props {
  item: AnaBookingInventoryItem;
  checked: boolean;
  onInventory: () => void;
  onToggle: (checked: boolean) => void;
}

const ItemsResultTableRow = observer(({ item, checked, onInventory, onToggle }: Props) => {
  const [showLogModal, setShowLogModal] = useState<boolean>(false);

  const handleInventory = async () => {
    const anaBookingInventoryPairId = item.anaBookingInventoryPairId;
    if (!anaBookingInventoryPairId) return;

    await Fetcher.put(
      `/arrangement/auto_reservation_inventory/ana_booking/items/${anaBookingInventoryPairId}/inventory.json`,
      {}
    );
    onInventory();
  };

  const handleCancelInventory = async () => {
    const anaBookingInventoryPairId = item.anaBookingInventoryPairId;
    if (!anaBookingInventoryPairId) return;
    await Fetcher.put(
      `/arrangement/auto_reservation_inventory/ana_booking/items/${anaBookingInventoryPairId}/cancel_inventory.json`,
      {}
    );
    onInventory();
  };

  return (
    <TableRow
      style={{
        background:
          !item.anaBookingInventoryPairAnaReservationId || !item.anaBookingInventoryPairAiOperatorReservationId
            ? rgba('red', 0.3)
            : 'auto'
      }}
    >
      <TableCell>
        {/* 一括棚卸用チェック */}
        <Checkbox
          checked={checked}
          disabled={!!item.anaBookingInventoryPairInventoriedAt}
          onChange={e => onToggle(e.target.checked)}
        />
      </TableCell>
      <TableCell>
        {/* ID */}
        {item.aiOperatorReservationId || '　'}
        <br />
        {item.anaReservationId || '　'}
      </TableCell>
      <TableCell>
        {/* 作成日時 */}
        {item.aiOperatorReservationCreatedAt?.format('YYYY-MM-DD HH:mm') || '　'}
        <br />
        {item.anaReservationCreatedAt?.format('YYYY-MM-DD HH:mm') || '　'}
      </TableCell>
      <TableCell>
        {/* 予約指示ステータス */}
        {item.aiOperatorReservationStatus}
      </TableCell>
      <TableCell>
        {/* 予約番号 */}
        {item.reservationNumber}
      </TableCell>
      <TableCell>
        {/* 搭乗日 */}
        {item.targetDate?.format('YYYY-MM-DD')}
      </TableCell>
      <TableCell>
        {/* 便名 */}
        {item.flightName}
      </TableCell>
      <TableCell>
        {/* 予約金額 */}
        {item.price?.toLocaleString()}
      </TableCell>
      <TableCell>
        {/* 予約日 */}
        {item.reservationDate?.format('YYYY-MM-DD')}
      </TableCell>
      <TableCell>
        {/* 完全自動 */}
        {item.aiOperatorReservationIsAutoProcessed ? '○' : ''}
      </TableCell>
      <TableCell>
        {/* 棚卸済 */}
        {item.aiOperatorIsInventoried || '　'}
        <br />
        {item.anaIsInventoried || '　'}
      </TableCell>
      <TableCell>
        {/* 棚卸者 */}
        {item.aiOperatorInventoriedBy || '　'}
        <br />
        {item.anaInventoriedBy || '　'}
      </TableCell>
      <TableCell>
        {/* 棚卸日時 */}
        {item.aiOperatorInventoriedAt?.format('YYYY-MM-DD HH:mm') || '　'}
        <br />
        {item.anaInventoriedAt?.format('YYYY-MM-DD HH:mm') || '　'}
      </TableCell>
      <TableCell>
        {/* Trip ID */}
        <Link
          href={`/arrangement/virtual_counter?trip_id=${item.aiOperatorTripId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {item.aiOperatorTripId || '　'}
        </Link>
        <br />
        <Link
          href={`/arrangement/virtual_counter?trip_id=${item.anaTripId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {item.anaTripId || '　'}
        </Link>
      </TableCell>
      <TableCell>
        {/* OrderItem ID */}
        {item.aiOperatorOrderItemId || '　'}
        <br />
        {item.anaOrderItemId || '　'}
      </TableCell>
      <TableCell>
        {/* Trace ID */}
        {item.aiOperatorTraceId || '　'}
        <br />
        {item.anaTraceId || '　'}
      </TableCell>
      <TableCell>
        {/* コメント */}
        {item.anaBookingInventoryPairId && (
          <p>
            (<Link onClick={() => setShowLogModal(true)}>コメント</Link>)
          </p>
        )}
      </TableCell>
      <TableCell>
        {/* 棚卸操作 */}
        {item.anaBookingInventoryPairId && item.anaBookingInventoryPairInventoriedAt ? (
          <Button size="small" onClick={() => handleCancelInventory()}>
            取消
          </Button>
        ) : (
          <Button size="small" onClick={() => handleInventory()}>
            棚卸完了
          </Button>
        )}
      </TableCell>
      {showLogModal && (item.anaTraceId || item.aiOperatorTraceId) && (
        <InventoryCommentModal
          inventoryPairId={item.anaBookingInventoryPairId}
          onClose={() => setShowLogModal(false)}
        />
      )}
    </TableRow>
  );
});

export default ItemsResultTableRow;
